import React from 'react';
import Modal, { ModalPrimaryButton, ModalSecondaryButton } from './Modal';

function ArchiveUserModal({ user, onClose, onConfirm }) {
  if (!user) return null;

  return (
    <Modal
      isOpen
      onClose={onClose}
      title={`Archive ${user.firstName}?`}
      subtitle={user.username ? `@${user.username}` : undefined}
      icon="fa-box-archive"
      tone="warning"
      size="md"
      footer={
        <>
          <ModalSecondaryButton onClick={onClose}>Cancel</ModalSecondaryButton>
          <ModalPrimaryButton onClick={onConfirm} tone="warning">
            <i className="fas fa-box-archive"></i>
            Archive user
          </ModalPrimaryButton>
        </>
      }
    >
      <p className="text-sm text-slate-cloud leading-relaxed">
        This deactivates the account and hides it from the active lists. Nothing
        is deleted - you can reactivate them at any time from the archive view.
      </p>
    </Modal>
  );
}

export default ArchiveUserModal;
